import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AddedCover from '../../../functions/AddedCover';
export default function CoverRequirements() {
    const location = useLocation();
    const navigate = useNavigate();
    const [questions, setQuestions] = useState([]);
    const updateCoverPageNo: number = 3;

    useEffect(() => {

        setQuestions(JSON.parse(localStorage.getItem('questions') || ""));
    }, [])

    function backNavigation() {
        navigate("/ChooseCover");
    }

    return (
        <span className="sidebar-component green-background">
            <p className="sidebar-header">Cover Requirements</p>
            <p className="additional-cover-title">You have added the following additional cover:</p> <br />
            <div>
                {questions.map((question, index) => {
                    return (
                        <div key={index}>
                            <AddedCover question={question} page={updateCoverPageNo} />
                        </div>
                    )
                }
                )}
            </div>
            <button className="btn update" onClick={() => backNavigation()}>Update</button>
        </span>
    )
}